/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { UserRole } from "constants/user"
import { storageHelper } from "utils/storage"

/**
 * Whether the current user may act on a return request — the decision CTAs
 * (`Review` / `Received`) and the `Confirm` that submits them.
 *
 * Cashiers may open a request and read it; approving a return, rejecting one or
 * confirming receipt of returned goods is not theirs to do (BP-57853).
 *
 * Reads the role off the stored user profile like `useCanViewStoreList` and
 * `useHideCustomerData` do, rather than `useMerchantDetail`'s per-store `GetMerchant`
 * role: neither host has merchant detail to read. The list container mounts under
 * order-manager's `/order/*` catch-all, which exposes no `:storeID` for
 * `useMerchantDetail` to resolve, and the webview page deliberately mounts without
 * `MerchantDetailGuard`.
 *
 * Deny-lists the cashier rather than allow-listing the others, so this only ever
 * removes the CTA from the one role the ticket names — a role string the profile
 * carries that we do not know about keeps acting. The backend remains the authority
 * on the submit itself; this is presentation.
 */
export const useCanActionReturnRequest = (): boolean =>
  storageHelper.getUserProfile()?.user_profile?.role !== UserRole.CASHIER
